var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "breadcrumb-layout" },
      [
        _c(
          "el-breadcrumb",
          { attrs: { separator: "/" } },
          [
            _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
              _vm._v("首页")
            ]),
            _vm._v(" "),
            _c("el-breadcrumb-item", [_vm._v("报名详细信息")])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "right",
            on: {
              click: function($event) {
                _vm.$router.back(-1)
              }
            }
          },
          [_vm._m(0)]
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "bidding-container",
        staticStyle: {
          width: "1100px",
          margin: "0 auto",
          padding: "10px",
          "background-color": "#f1f1f1"
        }
      },
      [
        _c("h1", { staticClass: "main-subtitle" }, [
          _vm._v(" 招标书标题： " + _vm._s(_vm.bidEnrollInfo.title))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "bidding-details" }, [
          _c("div", { staticClass: "form-single" }, [
            _c("div", { staticClass: "title" }, [_vm._v("联系人名：")]),
            _vm._v(" "),
            _c("div", { staticClass: "content" }, [
              _c("label", { staticClass: "mr20" }, [
                _vm._v(_vm._s(_vm.bidEnrollInfo.contactName))
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-single" }, [
            _c("div", { staticClass: "title" }, [_vm._v("联系电话：")]),
            _vm._v(" "),
            _c("div", { staticClass: "content" }, [
              _c("label", { staticClass: "mr20" }, [
                _vm._v(_vm._s(_vm.bidEnrollInfo.contactTel))
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-single" }, [
            _c("div", { staticClass: "title" }, [_vm._v("联系电子邮箱：")]),
            _vm._v(" "),
            _c("div", { staticClass: "content" }, [
              _c("label", { staticClass: "mr20" }, [
                _vm._v(_vm._s(_vm.bidEnrollInfo.contactEmail))
              ])
            ])
          ]),
          _vm._v(" "),
          _vm._m(1),
          _vm._v(" "),
          _c("table", { staticClass: "custom-tbl" }, [
            _vm._m(2),
            _vm._v(" "),
            _c(
              "tbody",
              { staticClass: "body" },
              _vm._l(_vm.bidEnrollQualiList, function(merchantQuali) {
                return _c("tr", { staticClass: "row" }, [
                  _c("td", [
                    _c("span", [_vm._v(_vm._s(merchantQuali.groupNo))])
                  ]),
                  _vm._v(" "),
                  _c(
                    "td",
                    {
                      staticClass: "align-left",
                      class: { selected: merchantQuali.qualiId != null }
                    },
                    [
                      _c("span", [
                        _vm._v(_vm._s(merchantQuali.callQualiTypeName))
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("td", [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.qualiKindList[merchantQuali.callQualiKind].text
                        )
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _c(
                      "div",
                      { staticClass: "table-addr" },
                      [
                        _c(
                          "el-radio-group",
                          {
                            attrs: { disabled: "" },
                            model: {
                              value: merchantQuali.callMandatory,
                              callback: function($$v) {
                                _vm.$set(merchantQuali, "callMandatory", $$v)
                              },
                              expression: "merchantQuali.callMandatory"
                            }
                          },
                          [
                            _c("el-radio", { attrs: { label: false } }, [
                              _vm._v("否")
                            ]),
                            _vm._v(" "),
                            _c("el-radio", { attrs: { label: true } }, [
                              _vm._v("是")
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ])
              })
            )
          ]),
          _vm._v(" "),
          _vm._m(3),
          _vm._v(" "),
          _c("table", { staticClass: "custom-tbl" }, [
            _vm._m(4),
            _vm._v(" "),
            _c(
              "tbody",
              { staticClass: "body align-left" },
              _vm._l(_vm.staffQualiList, function(staffQuali) {
                return _c("tr", { staticClass: "row" }, [
                  _c("td", { staticClass: "align-left" }, [
                    _vm._v(_vm._s(staffQuali.name))
                  ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "align-left" }, [
                    _vm._v(_vm._s(staffQuali.qualiName))
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _c("div", { staticClass: "table-addr" }, [
                      staffQuali.qualiLevel == 1
                        ? _c("span", [_vm._v("一级")])
                        : _vm._e(),
                      _vm._v(" "),
                      staffQuali.qualiLevel == 2
                        ? _c("span", [_vm._v("二级")])
                        : _vm._e(),
                      _vm._v(" "),
                      staffQuali.qualiLevel == 3
                        ? _c("span", [_vm._v("三级")])
                        : _vm._e(),
                      _vm._v(" "),
                      staffQuali.qualiLevel == 4
                        ? _c("span", [_vm._v("四级")])
                        : _vm._e(),
                      _vm._v(" "),
                      staffQuali.qualiLevel == 5
                        ? _c("span", [_vm._v("五级")])
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _c("div", { staticClass: "table-addr" }, [
                      staffQuali.mandatory
                        ? _c("span", [_vm._v("是")])
                        : _c("span", [_vm._v("否")])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(staffQuali.quantity))]),
                  _vm._v(" "),
                  _c("td", [
                    staffQuali.mandatory &&
                    staffQuali.quantity > staffQuali.staffQualiQuantity
                      ? _c("span", { staticClass: "font-red" }, [
                          _vm._v(_vm._s(staffQuali.staffQualiQuantity))
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    !staffQuali.mandatory &&
                    staffQuali.quantity > staffQuali.staffQualiQuantity
                      ? _c("span", { staticClass: "font-gold" }, [
                          _vm._v(_vm._s(staffQuali.staffQualiQuantity))
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    staffQuali.quantity <= staffQuali.staffQualiQuantity
                      ? _c("span", [
                          _vm._v(_vm._s(staffQuali.staffQualiQuantity))
                        ])
                      : _vm._e()
                  ])
                ])
              })
            )
          ]),
          _vm._v(" "),
          _vm._m(5),
          _vm._v(" "),
          _c("div", { staticClass: "form-single" }, [
            _c(
              "div",
              {
                staticClass: "content",
                staticStyle: { "padding-left": "38px" }
              },
              [
                _c("div", { staticClass: "file-area clearfix" }, [
                  _c(
                    "div",
                    { staticClass: "file-area clearfix" },
                    _vm._l(_vm.bidEnrollInfo.bidEnrollFileList, function(
                      file,
                      index
                    ) {
                      return _c("swb-file-item", {
                        attrs: {
                          trackKey: index,
                          fileName: file.name,
                          fileUuid: file.fileUuid,
                          fileBrowseUrl: file.fileBrowseUrl,
                          fileDownloadUrl: file.fileDownloadUrl,
                          fileMd5: file.fileMd5
                        }
                      })
                    })
                  )
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", [
            _vm.bidEnrollInfo.resultFlag == 0
              ? _c("span", [
                  _c(
                    "a",
                    {
                      staticClass: "swb-btn mr10",
                      on: {
                        click: function($event) {
                          _vm.AuditBidEnroll(
                            _vm.bidEnrollInfo.id,
                            1,
                            _vm.bidEnrollInfo.callDocId
                          )
                        }
                      }
                    },
                    [_vm._v("审核通过")]
                  ),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "swb-btn",
                      on: {
                        click: function($event) {
                          _vm.AuditBidEnroll(
                            _vm.bidEnrollInfo.id,
                            -1,
                            _vm.bidEnrollInfo.callDocId
                          )
                        }
                      }
                    },
                    [_vm._v("审核不通过")]
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.bidEnrollInfo.resultFlag == 1
              ? _c("span", [
                  _c("a", { staticClass: "swb-btn mr10" }, [
                    _vm._v("已通过审核")
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.bidEnrollInfo.resultFlag == -1
              ? _c("span", [
                  _c("a", { staticClass: "swb-btn" }, [_vm._v("未通过审核")])
                ])
              : _vm._e()
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("button", { staticClass: "swb-btn swb-btn-link" }, [
      _c("i", { staticClass: "icon iconfont icon-fanhui2 mr5" }),
      _vm._v("返回")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "content-caption dashed font18",
        staticStyle: { "background-color": "#fff" }
      },
      [
        _c("span", [
          _c("span", { staticClass: "color-laber" }),
          _vm._v("报名的资质")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", { staticClass: "head align-left" }, [
      _c("tr", { staticClass: "row" }, [
        _c("th", [_vm._v("招标资质组号")]),
        _vm._v(" "),
        _c("th", [_vm._v("招标资质名称")]),
        _vm._v(" "),
        _c("th", [_vm._v("招标资质类型")]),
        _vm._v(" "),
        _c("th", [_vm._v("是否必须")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [
        _c("span", { staticClass: "color-laber" }),
        _vm._v("要求的人员资质")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", { staticClass: "head align-left" }, [
      _c("tr", { staticClass: "row" }, [
        _c("th", [_vm._v("资质类型")]),
        _vm._v(" "),
        _c("th", [_vm._v("类型名称")]),
        _vm._v(" "),
        _c("th", [_vm._v("类型等级（及以上）")]),
        _vm._v(" "),
        _c("th", [_vm._v("是否必须")]),
        _vm._v(" "),
        _c("th", [_vm._v("要求数量")]),
        _vm._v(" "),
        _c("th", [_vm._v("资质数量")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "content-caption dashed font18",
        staticStyle: { "background-color": "#fff" }
      },
      [
        _c("span", [
          _c("span", { staticClass: "color-laber" }),
          _vm._v("报名附件")
        ])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8165d57c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8165d57c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/callbid/BidEnrollInfo.vue
// module id = 3329
// module chunks = 0